import { ContactEntity } from './contact-entity';

/**
 * Represents a trainer entity with contact information, skills, and background.
 * @extends ContactEntity
 * @class TrainerEntity
 */
export class TrainerEntity extends ContactEntity {
  /**
   * The age of the trainer.
   * @type {number}
   * @default 0
   * @example 35
   */
  public age: number = 0;

  /**
   * Array of technical skills that the trainer possesses.
   * @type {string[]}
   * @default []
   * @example ["C++", "Azure", ".NET", "MySQL", "CI/CD"]
   */
  public skills: string[] = [];

  /**
   * Biographical information about the trainer.
   * @type {string}
   * @default ""
   * @example "John has 10+ years of experience in cloud technologies..."
   */
  public bioData: string = "";
}
